import React, { useEffect } from 'react';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import './refundpolicy.css';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

const Refundpolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="refund-page">
      <NavBar />

      {/* Hero Section */}
      <section className="refund-hero">
        <div className="refund-hero-content">
          <h1 className="refund-hero-title">Refund Policy</h1>
          <p className="refund-hero-subtitle">
            Please read our refund terms carefully to understand how refunds and credits are handled by Easy Tax Experts.
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="refund-container">
        <section className="refund-section">
          <h2 className="refund-heading">Terms of Refund</h2>
          <div className="refund-content">
            <ul>
              <li>All amounts listed in the Tax Summary are shown in USD.</li>
              <li>
                Once payment is completed and the client has downloaded their documents, no refunds will be issued under any circumstances.
              </li>
              <li>
                However, based on the efforts and services rendered up to that point, a partial refund may be considered.
              </li>
              <li>
                Fees paid to Easy Tax Experts are non-refundable once you've confirmed the filing of your tax return,
                and the return has been successfully submitted.
              </li>
              <li>
                If you're eligible for a referral reward, it will be credited to your account after April 25,
                or you may apply it as a discount during payment.
              </li>
              <li>
                Please note that Tax Filing Fees do not cover FBAR filing fees unless specifically requested.
              </li>
            </ul>
          </div>
        </section>
      </main>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Refundpolicy;
